module.exports = __webpack_public_path__ + "static/img/EditCard.95abb41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EditCard.png
// module id = b2/w
// module chunks = 3